module.exports = __webpack_public_path__ + "img/logo2.78e40fdf.svg";